// @core/api/endpoints/authn/sign_in.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SignInRequest,
  SignInResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Sign in with email/username and password
 * Authenticates a user using email or username with password. Returns access and refresh tokens on success. If 2FA is enabled, requires the two_factor_code parameter.
 * @public This endpoint does not require authentication
 */
export async function SignIn(
  data: SignInRequest,
  options?: RequestOptions
): Promise<SignInResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/signin`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<SignInResponse>(requestPath, data, requestOptions);
}
